import types from './types';

export const getPossibleFieldsBatchUpdate = () => ({
  type: types.GAT_POSSIBLE_FIELDS_LIST_BATCH_UPDATE
});

export const setContactBatchMode = (contactBatchMode) => ({
  type: types.SET_CONTACT_BATCH_MODE,
  contactBatchMode
});

export default {
  getPossibleFieldsBatchUpdate,
  setContactBatchMode
};
